var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import IconContainer, { IconSVG } from './IconContainer';
var IconDownVote = React.memo(function (props) {
    var color = props.color, rest = __rest(props, ["color"]);
    return (React.createElement(IconContainer, __assign({}, rest),
        React.createElement(IconSVG, { color: color, inheritColor: props.inheritColor, fill: "none", x: "0px", y: "0px", viewBox: "0 0 30 30", strokeLinejoin: "round", strokeLinecap: "round" },
            React.createElement("g", { transform: "translate(-205.52 -702.879) rotate(30)" },
                React.createElement("g", { transform: "translate(536 512)" },
                    React.createElement("path", { d: "M17.9-5.5L17.9-5.5c1.1,0.6,1.5,2.1,0.9,3.2l-5.3,9.2c-0.6,1.1-2.1,1.5-3.2,0.9l0,0C9.1,7.1,8.7,5.7,9.3,4.5\n\t\t\tl5.3-9.2C15.3-5.8,16.7-6.2,17.9-5.5z" }),
                    React.createElement("path", { d: "M17.2-4.4L17.2-4.4c0.5,0.3,0.7,1,0.4,1.5l-5.3,9.2c-0.3,0.5-1,0.7-1.5,0.4l0,0c-0.5-0.3-0.7-1-0.4-1.5\n\t\t\tL15.7-4C16-4.5,16.7-4.7,17.2-4.4z" })),
                React.createElement("g", { transform: "translate(538 501)" },
                    React.createElement("path", { d: "M3,0.8L3,0.8c0.8,0.5,1.1,1.6,0.6,2.4L0.1,9.3c-0.5,0.8-1.6,1.1-2.4,0.6l0,0C-3.2,9.4-3.5,8.4-3,7.5l3.5-6.1\n\t\t\tC1,0.6,2.1,0.3,3,0.8z" }),
                    React.createElement("path", { d: "M2.3,1.9L2.3,1.9C2.6,2,2.6,2.3,2.5,2.5L-1,8.7C-1.2,8.9-1.5,9-1.7,8.8l0,0C-1.9,8.7-2,8.4-1.9,8.2L1.7,2\n\t\t\tC1.8,1.8,2.1,1.7,2.3,1.9z" })),
                React.createElement("g", { transform: "translate(544 526) rotate(180)" },
                    React.createElement("path", { d: "M-8.2,9.6l-1.8,3.1l-8.3-6.8L-8.2,9.6z" }),
                    React.createElement("path", { d: "M-8.2,9.6l-1.8,3.1l-8.3-6.8L-8.2,9.6z" })),
                React.createElement("g", { transform: "translate(539 505)" },
                    React.createElement("path", { d: "M10,2.8L5.9,9.9l-5.3-5L3,0.8L10,2.8z" }),
                    React.createElement("path", { d: "M4.3,3.8L3.9,4.4l1.5,1.4l0.9-1.5L4.3,3.8 M10,2.8L5.9,9.9l-5.3-5L3,0.8L10,2.8z" }))),
            React.createElement("g", null,
                React.createElement("path", { d: "M23.6,1L29,6.4" }),
                React.createElement("path", { d: "M29,1l-5.4,5.4" })))));
});
export default IconDownVote;
//# sourceMappingURL=IconDownVote.js.map